// FormikTextField.jsx
import { InputAdornment, TextField } from "@mui/material";
import { useField } from "formik";

const FormikTextField = ({
  name,
  label,
  type = "text",
  disabled = false,
  startAdornment = null,
  InputLabelProps,
  placeholder,
}) => {
  const [field, meta] = useField(name);

  const inputProps = {};
  if (startAdornment) {
    inputProps.startAdornment = (
      <InputAdornment position="start">{startAdornment}</InputAdornment>
    );
  }
  const isPhone = type === "tel" || ["mobile_number", "phoneNumber"].includes(name);

  return (
    <TextField
      {...field}
      fullWidth
      placeholder={placeholder}
      variant="standard"
      label={label}
      type={type}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error}
      disabled={disabled}
      autoComplete="one-time-code"
      InputLabelProps={InputLabelProps}
      // Native input attributes + input sanitization for phone
      inputProps={
        isPhone
          ? {
            inputMode: "numeric",        // phone keypad hint
            pattern: "[0-9]*",           // numeric-only hint
            maxLength: 10,               // character cap applies to tel/text
            onInput: (e) => {
              e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
            },                           // live clamp to 10 digits
          }
          : undefined
      }
      InputProps={inputProps}
    />
  );
};

export default FormikTextField;
